import { partial } from 'lodash/fp';
import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';
import searchable from './traits/searchable';

const BASE_URL = '/reservations';
export default function ReservationComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);
    return type.create(ReservationComponent, searchable(partial(request, ['/searchnew'])), {
        assignSlot(reservationId: $TSFixMe) {
            return request('/assignSlot', { reservationId });
        },

        checkIn(reservationIds: $TSFixMe, disablePreauthorization = false) {
            return request('/checkIn', {
                reservationIds,
                disablePreauthorizationForStart: disablePreauthorization,
            });
        },

        undoCheckIn(reservationIds: $TSFixMe, reason: $TSFixMe) {
            return request('/undoCheckIn', { reservationIds, reason });
        },

        checkOut(
            reservationIds: $TSFixMe,
            closeBalancedBills: $TSFixMe,
            checkOutWithUnbalancedBill: $TSFixMe,
            reason: $TSFixMe
        ) {
            return request('/checkOut', { closeBalancedBills, checkOutWithUnbalancedBill, reason, reservationIds });
        },

        undoCheckOut(reservationIds: $TSFixMe, reason: $TSFixMe) {
            return request('/undoCheckOut', { reservationIds, reason });
        },

        cancel(
            reservationIds: $TSFixMe,
            cancellationReason: $TSFixMe,
            applyCancellationFee: $TSFixMe,
            reasonDetail: $TSFixMe,
            sendEmail: $TSFixMe
        ) {
            return request('/cancel', {
                cancellationReason,
                applyCancellationFee,
                reasonDetail,
                reservationIds,
                sendEmail,
            });
        },

        sendEmail(
            reservationIds: $TSFixMe,
            mailType: $TSFixMe,
            receiver: $TSFixMe,
            customEmail: $TSFixMe,
            languageCode: $TSFixMe
        ) {
            return request('/sendEmail', { customEmail, languageCode, receiver, mailType, reservationIds });
        },

        updateResource(
            reservationId: $TSFixMe,
            resourceId: $TSFixMe,
            fallbackToBranch: $TSFixMe,
            updateBlockAvailability: $TSFixMe
        ) {
            return request('/updateAssignedResource', {
                reservationId,
                resourceId,
                fallbackToBranch,
                updateBlockAvailability,
            });
        },

        updateLocked(reservationIds: $TSFixMe, locked: $TSFixMe) {
            return request('/updateLocked', { reservationIds, isLocked: locked });
        },

        updateOwner(reservationId: $TSFixMe, customerId: $TSFixMe) {
            return request('/updateOwner', { reservationId, customerId });
        },

        updateChannelNumber(reservationIds: $TSFixMe, channelNumber: $TSFixMe) {
            return request('/updateChannelNumber', {
                reservationIds,
                channelNumber,
            });
        },

        addProductOrder({ enterpriseId, productOrders }: $TSFixMe) {
            return request('/addProductOrder', {
                enterpriseId,
                productOrders,
            });
        },

        updateRate(reservationIds: $TSFixMe, rateId: $TSFixMe, keepOldPrice: $TSFixMe) {
            return request('/updateRate', {
                reservationIds,
                rateId,
                keepOldPrice,
            });
        },

        setDefaultProductOrderAmount({ productOrderAmountUpdates, reason }: $TSFixMe) {
            return request('/setDefaultProductOrderAmount', {
                productOrderAmountUpdates,
                reason,
            });
        },

        previewAssignment({ enterpriseId, startUtc, endUtc }: $TSFixMe) {
            return request('/previewAssignment', { enterpriseId, startUtc, endUtc });
        },

        optimizeAssignment({ enterpriseId, startUtc, endUtc }: $TSFixMe) {
            return request('/optimizeAssignment', { enterpriseId, startUtc, endUtc });
        },

        price({ reservations, profileId, enterpriseId, serviceId }: $TSFixMe) {
            return request('/price', { reservations, profileId, enterpriseId, serviceId });
        },

        update({ reservationUpdates, enterpriseId }: $TSFixMe) {
            return request('/update', { reservationUpdates, enterpriseId });
        },
    });
}
